// extracted by mini-css-extract-plugin
module.exports = {"vendorListWidgetItemWrapper":"_2WZ2dosxFOSRJvZScaBOB","vendorListWidgetItemLinkRowArrow":"_1EmUPM_l30S5sfZ6oyz_ck"};